// https://www.dbos.dev/solutions/data-pipeline-platform

import { SiteLayout } from '@components/layout/SiteLayout';
import { Dropdown, DropdownList, DropdownToggle } from '@components/webflow';

export function SolutionsDataPipelinePlatformPage() {
  return (
    <SiteLayout banner={false} footerCta={null}>
      <div className="background-glow-top-right">
        <section className="hero-center-wrapper">
          <h1 className="text-heading-caption">durable Data Pipelines</h1>
          <h2 className="text-heading-h1">
            Durable<span className="text-gradient">{' Data Pipelines'}</span>{' '}
          </h2>
          <p className="text-body">
            Breakthrough serverless platform makes data pipelines durable, scalable, and observable by default.
          </p>
          <div className="button-row-vertical">
            <div className="button-primary-border">
              <a
                href="https://console.dbos.dev/"
                className="button-cta button-primary button-navigation w-inline-block"
              >
                <div className="text-block">Start for free</div>
              </a>
            </div>
            <div className="text-caption-micro">No credit card required.</div>
          </div>
          <div className="card-creators-small">
            <p className="text-body-highlight">From the creators of Postgres and Apache Spark</p>
          </div>
        </section>
      </div>
      <div className="spacer-3x shorter2" />
      <div className="background-glow-center-right">
        <div className="spacer-3x" />
        <section className="section-wrapper">
          <div className="card-benefit">
            <div className="card-benefit-content-left">
              <h2 className="text-heading-caption">Data Pipeline Deployment Made Easy</h2>
              <h3 className="text-heading-h2">
                {'Fail-proof '}
                <br />
                Data Pipeline Execution
              </h3>
              <p className="text-body text-alignment-left">
                Build Python or TypeScript data pipelines that extract, transform, load, and analyze data.
                <br />
                <br />
                {'DBOS makes them crash-proof, observable, and scalable for you. '}
              </p>
              <div className="button-row-horizontal">
                <a href="https://console.dbos.dev/" className="button-cta button-secondary w-inline-block">
                  <div className="text-block">See how it works</div>
                </a>
                <div className="text-caption-micro">No credit card required.</div>
              </div>
            </div>
            <div className="card-benefit-code-block">
              <div style={{ paddingTop: '56.17021276595745%' }} className="w-embed-youtubevideo">
                <iframe
                  src="https://www.youtube.com/embed/6RgRBoW3cw8?rel=0&controls=1&autoplay=0&mute=0&start=0"
                  frameBorder="0"
                  style={{
                    position: 'absolute',
                    left: '0',
                    top: '0',
                    width: '100%',
                    height: '100%',
                    pointerEvents: 'auto',
                  }}
                  allow="autoplay; encrypted-media"
                  allowFullScreen
                  title="Building crashproof applications effortlessly with DBOS"
                />
              </div>
            </div>
          </div>
        </section>
        <div className="spacer-3x" />
      </div>
      <section id="how-it-works" className="section-wrapper">
        <div className="card-how-it-works">
          <h2 className="text-heading-caption">How it works</h2>
          <div className="w-layout-hflex flex-block-8">
            <div>
              <h3 className="heading-style-h3">Launch a Durable Data Pipeline in Minutes</h3>
              <p className="text-body text-alignment-left">We’re not kidding, DBOS is effortless.</p>
            </div>
            <div className="button-row-horizontal">
              <div className="text-caption-micro">No credit card required.</div>
              <div className="button-primary-border">
                <a
                  href="https://console.dbos.dev/"
                  className="button-cta button-primary button-navigation w-inline-block"
                >
                  <div className="text-block">Start for free</div>
                </a>
              </div>
            </div>
          </div>
          <div className="w-layout-hflex flex-block-9">
            <a href="https://console.dbos.dev/launch" className="card-how-it-works-item w-inline-block">
              <p className="text-caption-pill text-alignment-right">{'<1 min'}</p>
              <div className="div-block-30" />
              <img
                width="20"
                height="20"
                alt=""
                loading="lazy"
                src="/assets/images/6758d7c1daeb1ffb5868934c_user-plus.svg"
                className="card-how-it-works-icon"
              />
              <h4 className="text-heading-h5">1. Create a free account</h4>
              <p className="text-body text-alignment-left">Sign up to DBOS in seconds.</p>
              <div className="card-how-it-works-overlay" />
              <img
                src="/assets/images/6758d7797dd2d71709a4b164_sign-up.png"
                loading="lazy"
                alt=""
                className="card-how-it-works-background"
              />
            </a>
            <a href="https://console.dbos.dev/launch" className="card-how-it-works-item w-inline-block">
              <p className="text-caption-pill text-alignment-right">1 min</p>
              <div className="div-block-30" />
              <img
                width="20"
                height="20"
                alt=""
                loading="lazy"
                src="/assets/images/6758d7c151a010c8985b8836_package.svg"
                className="card-how-it-works-icon"
              />
              <h4 className="text-heading-h5">2. Launch ‘Cron Starter’ template</h4>
              <p className="text-body text-alignment-left">Start by building a scheduled data pipeline.</p>
              <div className="card-how-it-works-overlay" />
              <img
                src="/assets/images/6758d77992fecccbbc873ece_cron-starter.png"
                loading="lazy"
                alt=""
                className="card-how-it-works-background"
              />
            </a>
            <a href="https://console.dbos.dev/launch" className="card-how-it-works-item w-inline-block">
              <p className="text-caption-pill text-alignment-right">3 min</p>
              <div className="div-block-30" />
              <img
                width="20"
                height="20"
                alt=""
                loading="lazy"
                src="/assets/images/6758d7c1dd7aea7c5dbb2879_code.svg"
                className="card-how-it-works-icon"
              />
              <h4 className="text-heading-h5">3. Add your pipeline workflow steps</h4>
              <p className="text-body text-alignment-left">Customize your data pipeline workflow.</p>
              <div className="card-how-it-works-overlay" />
              <img
                src="/assets/images/6758d7795b9750161dca3338_annotations.png"
                loading="lazy"
                alt=""
                className="card-how-it-works-background"
              />
            </a>
            <a href="https://console.dbos.dev/launch" className="card-how-it-works-item w-inline-block">
              <p className="text-caption-pill text-alignment-right">1 min</p>
              <div className="div-block-30" />
              <img
                width="20"
                height="20"
                alt=""
                loading="lazy"
                src="/assets/images/6758d7c1fbb307648e5499cd_zap.svg"
                className="card-how-it-works-icon"
              />
              <h4 className="text-heading-h5">4. Deploy your pipeline app.</h4>
              <p className="text-body text-alignment-left">Watch it run reliably, forever.</p>
              <div className="card-how-it-works-overlay" />
              <img
                src="/assets/images/6758d779fbb307648e545cbb_redeploy.png"
                loading="lazy"
                alt=""
                className="card-how-it-works-background"
              />
            </a>
          </div>
        </div>
      </section>
      <div className="spacer-3x" />
      <div className="background-glow-center-left">
        <section className="section-wrapper">
          <div className="card-cta-large-wrapper">
            <div className="card-cta-large-glow-right">
              <div className="cta-large-content-left">
                <h2 className="text-heading-h2">
                  {'Unmatched Data Pipeline '}
                  <span className="text-gradient">Cost Efficiency</span>
                </h2>
                <p className="text-body text-alignment-left">
                  DBOS executes Python and TypeScript data pipelines orders of magnitude faster than other serverless
                  platforms. Perfect for scheduled cron jobs, event-driven workflows, AI RAG applications, and more.
                </p>
                <div className="button-row-horizontal">
                  <div className="button-primary-border">
                    <a
                      href="https://docs.dbos.dev/"
                      className="button-cta button-primary button-navigation w-inline-block"
                    >
                      <div className="text-block">Read the docs</div>
                    </a>
                  </div>
                  <div className="text-caption-micro" />
                </div>
                <h3 className="text-list-caption">Radically simplifies data engineering</h3>
                <ul role="list" className="text-list">
                  <li className="text-list-item">
                    {'Durability framework ensures crash-proof, exactly-once processing. '}
                  </li>
                  <li className="text-list-item">
                    {'Cuts coding 10x by automating error-handling, durability, scalability. '}
                  </li>
                  <li className="text-list-item">Emits OpenTelemetry traces for easy auditing.</li>
                </ul>
              </div>
              <div className="cta-large-content-right">
                <div className="card-testimonial-wrapper">
                  <p className="text-heading-h4">
                    {
                      '"With DBOS, developers can build applications in days that now take months on conventional platforms."'
                    }
                  </p>
                  <div className="w-layout-hflex card-testimonial-company">
                    <div className="card-testimonial-source">
                      <img
                        src="/assets/images/673ab74082767acb2d4c191c_Matei-Zaharia.png"
                        loading="lazy"
                        alt=""
                        className="profile-medium-image"
                      />
                      <div className="w-layout-hflex card-testimonial-source-text">
                        <div className="text-body text-alignment-left">Matei Zaharia</div>
                        <div className="text-caption-micro">Co-Founder, Databricks</div>
                      </div>
                    </div>
                    <img
                      src="/assets/images/673ab683b32cf03625b9fa9b_databricks-logo.png"
                      loading="lazy"
                      alt=""
                      className="card-testimonial-logo"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className="spacer-3x" />
      </div>
      <section className="section-wrapper">
        <div className="card-use-cases">
          <h2 className="text-heading-caption">Data Pipeline Engineering Use Cases</h2>
          <h3 className="text-heading-h2">Durable Data Pipeline Possibilities</h3>
          <div className="w-layout-hflex card-use-cases-row">
            <div className="w-layout-vflex card-use-cases-item">
              <h4 className="text-heading-h5">Scheduled Cron Jobs</h4>
              <p className="text-body text-alignment-left">
                Build data pipelines in Python or TypeScript; schedule them to run using crontab syntax.
              </p>
            </div>
            <div className="w-layout-vflex card-use-cases-item">
              <h4 className="text-heading-h5">Event-driven Workflows</h4>
              <p className="text-body text-alignment-left">
                {'Consume events from Apache Kafka topics with guaranteed exactly-once processing. '}
              </p>
            </div>
            <div className="w-layout-vflex card-use-cases-item">
              <h4 className="text-heading-h5">AI / RAG Pipelines</h4>
              <p className="text-body text-alignment-left">
                Durability eliminates AI data pipeline headaches like LLM timeouts and rate limiting.
              </p>
            </div>
            <div className="w-layout-vflex card-use-cases-item">
              <h4 className="text-heading-h5">Human-in-the-loop</h4>
              <p className="text-body text-alignment-left">
                Include manual steps in your data pipeline workflows. DBOS handles async waiting and timeouts for you.
              </p>
            </div>
          </div>
          <div className="card-insight-2-container">
            <a href="/blog/aws-lambda-hidden-wait-costs" className="card-insight-large w-inline-block">
              <img
                src="/assets/images/677791b89dd4afe8726a8a53_AWS-Lambda-Hidden-Costs.jpg"
                loading="lazy"
                alt=""
                sizes="100vw"
                srcSet="/assets/images/677791b89dd4afe8726a8a53_AWS-Lambda-Hidden-Costs-p-500.jpg 500w, /assets/images/677791b89dd4afe8726a8a53_AWS-Lambda-Hidden-Costs-p-800.jpg 800w, /assets/images/677791b89dd4afe8726a8a53_AWS-Lambda-Hidden-Costs-p-1080.jpg 1080w, /assets/images/677791b89dd4afe8726a8a53_AWS-Lambda-Hidden-Costs.jpg 1280w"
                className="card-insight-image"
              />
              <div className="card-insight-large-content">
                <h4 className="text-heading-h4 text-heading-h4-insight">
                  Is Your Serverless Code Costing More to Wait than to Compute?
                </h4>
                <p className="text-body text-alignment-left">
                  Lightweight durable execution library versus heavyweight durable workflow orchestration services,
                  making programs crashproof without changing the way they're built
                </p>
                <div className="card-insight-meta">
                  <div className="w-layout-hflex profile-small profile-small-container">
                    <img
                      src="/assets/images/67778fe92e7ce5ddc7b6b560_Peter-Kraft.png"
                      loading="lazy"
                      alt=""
                      className="profile-small-image"
                    />
                    <div className="text-body text-body-highlight">Peter Kraft</div>
                  </div>
                  <div className="text-caption-micro">October 10, 2024</div>
                </div>
              </div>
            </a>
            <a
              href="/blog/serverless-rag-tutorial-llamaindex-dbos-python"
              className="card-insight-large w-inline-block"
            >
              <img
                src="/assets/images/67779042e28f5a0d2cfbbf8a_Python-RAG-LlamaIndex-Tutorial-DBOS.jpg"
                loading="lazy"
                alt=""
                sizes="100vw"
                srcSet="/assets/images/67779042e28f5a0d2cfbbf8a_Python-RAG-LlamaIndex-Tutorial-DBOS-p-500.jpg 500w, /assets/images/67779042e28f5a0d2cfbbf8a_Python-RAG-LlamaIndex-Tutorial-DBOS-p-800.jpg 800w, /assets/images/67779042e28f5a0d2cfbbf8a_Python-RAG-LlamaIndex-Tutorial-DBOS-p-1080.jpg 1080w, /assets/images/67779042e28f5a0d2cfbbf8a_Python-RAG-LlamaIndex-Tutorial-DBOS.jpg 1280w"
                className="card-insight-image"
              />
              <div className="card-insight-large-content">
                <h4 className="text-heading-h4 text-heading-h4-insight">
                  How to Build a Durable RAG App in 9 Lines of Code
                </h4>
                <p className="text-body text-alignment-left">
                  Lightweight durable execution library versus heavyweight durable workflow orchestration services,
                  making programs crashproof without changing the way they're built
                </p>
                <div className="card-insight-meta">
                  <div className="w-layout-hflex profile-small profile-small-container">
                    <img
                      src="/assets/images/67778fe97fda397cbea46dc3_Qian-Li.jpeg"
                      loading="lazy"
                      alt=""
                      sizes="192px"
                      srcSet="/assets/images/67778fe97fda397cbea46dc3_Qian-Li-p-500.jpeg 500w, /assets/images/67778fe97fda397cbea46dc3_Qian-Li-p-800.jpeg 800w, /assets/images/67778fe97fda397cbea46dc3_Qian-Li.jpeg 1024w"
                      className="profile-small-image"
                    />
                    <div className="text-body text-body-highlight">Qian Li</div>
                  </div>
                  <div className="text-caption-micro">October 17, 2024</div>
                </div>
              </div>
            </a>
          </div>
        </div>
      </section>
      <div className="spacer-3x" />
      <section className="section-wrapper">
        <div className="card-accordion-faq-alt">
          <div className="w-layout-hflex accordion-content-left">
            <h2 className="text-heading-caption">FAQs</h2>
            <h3 className="text-heading-h2">Common Questions</h3>
            <p className="text-body text-alignment-left text-margin-bottom">
              We’ll do our best to cover all bases.
              <br />
              In case you have additional questions about agentic AI, speak with our team.
            </p>
            <a href="/contact" className="button-cta button-secondary w-inline-block">
              <div className="text-block">Speak with our team</div>
            </a>
          </div>
          <div className="w-layout-hflex accordion-content-right">
            <Dropdown data-hover="false" data-delay="0" className="card-accordion-faq w-dropdown">
              <DropdownToggle className="dropdown-toggle w-dropdown-toggle">
                <h3 className="text-accordion-title">What is a data pipeline?</h3>
                <div className="code-embed-2 w-embed">+</div>
              </DropdownToggle>
              <DropdownList className="dropdown-list w-dropdown-list">
                <div className="text-body-rich w-richtext">
                  <p>
                    A data pipeline is a series of programmatic processes that move data from various sources, transform
                    it as needed, and store it in a format or system, where it can be analyzed. .<br />
                    <br />
                    <br />
                    {
                      'WIth DBOS, you code your data pipelines and other data engineering workflows in Python or TypeScript, just as you normally would, and then add simple decorators which instruct DBOS\u00a0on how to provide access to them (endpoints)\u00a0and how to execute them durably with guaranteed exactly-one processing.'
                    }
                  </p>
                </div>
              </DropdownList>
            </Dropdown>
            <Dropdown data-hover="false" data-delay="0" className="card-accordion-faq w-dropdown">
              <DropdownToggle className="dropdown-toggle w-dropdown-toggle">
                <h3 className="text-accordion-title">Why does durability matter to data pipelines?</h3>
                <div className="code-embed-2 w-embed">+</div>
              </DropdownToggle>
              <DropdownList className="dropdown-list w-dropdown-list">
                <div className="text-body-rich w-richtext">
                  <p>
                    Data pipelines are often used to automate the delivery and analysis of data used in real-time
                    automation and mission-critical decision making.
                  </p>
                  <p>
                    With so much riding on the success of your data pipelines, durability ensures that they execute the
                    way they are intended to, even if they are interrupted by technical glitches, or if they have to
                    wait a long time for humans in the loop.
                    <br />
                    <br />
                    {
                      'DBOS\u00a0makes your data pipelines durable, simply by adding a few annotations to your Python or TypeScript code, DBOS ensures that workflows execute durably. If they are interrupted, they automatically resume executing where they left off when restarted. Besides ensuring that your data pipelines execute durably, DBOS\u00a0reduces the amount of coding and technical debt it would normally require to ensure durable execution.'
                    }
                  </p>
                </div>
              </DropdownList>
            </Dropdown>
            <Dropdown data-hover="false" data-delay="0" className="card-accordion-faq w-dropdown">
              <DropdownToggle className="dropdown-toggle w-dropdown-toggle">
                <h3 className="text-accordion-title">Why should I run my data pipelines on DBOS?</h3>
                <div className="code-embed-2 w-embed">+</div>
              </DropdownToggle>
              <DropdownList className="dropdown-list w-dropdown-list">
                <div className="text-body-rich w-richtext">
                  <p>
                    {
                      'You can deploy durable data pipelines built with open source DBOS\u00a0Transact to any cloud or even on premises.'
                    }
                  </p>
                  <p>
                    {
                      'You also have the option to deploy to DBOS\u00a0Cloud, a serverless compute platform built to radically simplify data pipeline development and execution. Besides providing a platform on which to host and run your data pipelines, DBOS\u00a0makes the following automatic:'
                    }
                  </p>
                  <p>
                    Scalability - Scale from zero to millions of requests in seconds--and back to zero when not in use.
                    Only pay for what you use.
                    <br />
                    <br />
                    {
                      'Durability - DBOS\u00a0ensures your data pipelines execute the way the are intended to, no matter what. If they are interrupted by a technical glitch, DBOS automatically restarts them and resumes execution from where it left off before the interruption.'
                    }
                    <br />
                    <br />
                    {
                      'Observability - DBOS\u00a0outputs OpenTelemetry traces and metrics for your data pipelines, so you have complete visibility into their execution history. It makes troubleshooting, auditing, and performance optimization much easier.'
                    }
                    <br />
                    <br />
                    {
                      'In addition to making your data pipelines more durable, scalable, and observable, DBOS\u00a0is the only serverless platform that does NOT\u00a0not charge you for time your code spends waiting for backend responses. This saves you a lot of money compared to other platforms like AWS\u00a0Lambda.'
                    }
                  </p>
                </div>
              </DropdownList>
            </Dropdown>
            <Dropdown data-hover="false" data-delay="0" className="card-accordion-faq w-dropdown">
              <DropdownToggle className="dropdown-toggle w-dropdown-toggle">
                <h3 className="text-accordion-title">What backend services can my AI workflow access from DBOS?</h3>
                <div className="code-embed-2 w-embed">+</div>
              </DropdownToggle>
              <DropdownList className="dropdown-list w-dropdown-list">
                <div className="text-body-rich w-richtext">
                  <p>
                    {
                      'DBOS\u00a0runs standard Python or TypeScript code. Your applications can interface with any backend system via API\u00a0calls, or directly access Postgres-compatible databases via SQL. '
                    }
                    <br />
                    <br />
                    {
                      'DBOS\u00a0ensures that workflows orchestrating calls to remote services and backend databases always execute durably, with OpenTelemetry observability traces output by default for easy troubleshooting and auditing.'
                    }
                  </p>
                </div>
              </DropdownList>
            </Dropdown>
          </div>
        </div>
      </section>
      <div className="spacer-3x" />
    </SiteLayout>
  );
}
